import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { About } from "@/components/landing/About";
import { Counters } from "@/components/landing/Counters";
import { Venues } from "@/components/landing/Venues";
import { Amenities } from "@/components/landing/Amenities";
import { Testimonials } from "@/components/landing/Testimonials";
import { Gallery } from "@/components/landing/Gallery";
import { Contact } from "@/components/landing/Contact";
import { LocationMap } from "@/components/landing/LocationMap";
import { Footer } from "@/components/landing/Footer";
import { WhatsAppFloat } from "@/components/landing/WhatsAppFloat";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <About />
      <Counters />
      <Venues />
      <Amenities />
      <Testimonials />
      <Gallery />
      <Contact />
      <LocationMap />
      <Footer />
      <WhatsAppFloat />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
